import styled, {css} from 'styled-components';
import {IoIosCloseCircleOutline} from 'react-icons/io';

interface ItemProps {
  readonly theme?: string;
}

export const ToastSection = styled.section`
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 10;
  right: 0;
  left: 0;
  white-space: pre-line;
`;

export const ToastContainer = styled.div<ItemProps>`
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  padding: 10px 30px;
  margin-top: 30px;
  display: flex;

  ${props => {
    let theme = '';

    if (props.theme === 'success') {
      theme = `
        border: solid 1px #51E363;
        background-color: #F6FFF7;
      `;
    } else if (props.theme === 'error') {
      theme = `
        border: solid 1px rgba(245,75,35,0.9);
        background-color: #FFF4F1;
      `;
    } else if (props.theme === 'warning') {
      theme = `
        border: solid 1px #FDD112;
        background-color: #FFFEFA;
      `;
    } else {
      theme = `
        border: solid 1px #51E363;
        background-color: #F6FFF7;
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;

export const ToastText = styled.span<ItemProps>`
  font-weight: 500;
  font-size: 14px;

  ${props => {
    let theme = '';

    if (props.theme === 'success') {
      theme = `
        color: #43C853;
      `;
    } else if (props.theme === 'error') {
      theme = `
        color: #F54B23;
      `;
    } else if (props.theme === 'warning') {
      theme = `
        color: #DEB919;
      `;
    } else {
      theme = `
        color: #43C853;
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;

export const ToastIcon = styled(IoIosCloseCircleOutline)<ItemProps>`
  cursor: pointer;
  margin-left: 10px;
  font-size: 25px;

  ${props => {
    let theme = '';

    if (props.theme === 'success') {
      theme = `
        color: #43C853;
      `;
    } else if (props.theme === 'error') {
      theme = `
        color: #F54B23;
      `;
    } else if (props.theme === 'warning') {
      theme = `
        color: #DEB919;
      `;
    } else {
      theme = `
        color: #43C853;
      `;
    }

    return css`
       {
        ${theme}
      }
    `;
  }};
`;
